import * as UiActions from '../actions/ui.actions';
import * as AuthActions from '../../auth/actions/auth.actions';
import { SimpleNotification } from './../../shared/components/simple-notification/models/SimpleNotification.model';

// App State
export interface State {
  autosaved: boolean;
  autosaving: boolean;
  projectView: boolean;
  searchOpened: boolean;
  currentLanguage: string;
  sidebarCollapsed: boolean;
  currentProjectSection: string | null;
  notifications: SimpleNotification[];
}

// Initial State
export const initialState: State = {
  autosaved: false,
  autosaving: false,
  projectView: false,
  searchOpened: false,
  currentLanguage: '',
  sidebarCollapsed: true,
  currentProjectSection: null,
  notifications: []
};

// Export Reducer
export function reducer(state = initialState, action: UiActions.Actions | AuthActions.LogoutSuccess): State {
  switch (action.type) {

    // Toggle Search
    case UiActions.START_OR_STOP_SEARCH:
      return { ...state, searchOpened: !state.searchOpened };

    // Toggle Project View
    case UiActions.PROJECT_VIEW:
      return { ...state, projectView: action.payload };

    // Collapse Sidebar
    case UiActions.COLLAPSE_SIDEBAR:
      return { ...state, sidebarCollapsed: !state.sidebarCollapsed };

    // Auto saved
    case UiActions.AUTO_SAVED:
      return { ...state, autosaving: false, autosaved: true };

    // Auto saving
    case UiActions.AUTO_SAVING:
      return { ...state, autosaving: true, autosaved: false };

    // Clear autosave
    case UiActions.CLEAR_AUTO_SAVE:
      return { ...state, autosaving: false, autosaved: false };

    // Language Change
    case UiActions.LANGUAGE_CHANGE:
      return { ...state, currentLanguage: action.payload };

    // Select Project Section
    case UiActions.PROJECT_SECTION_SELECTED:
      return { ...state, currentProjectSection: action.payload };

    // User Logout
    case AuthActions.LOGOUT_SUCCESS:
      return initialState;

    // Add Simple Notification
    case UiActions.ADD_SIMPLE_NOTIFICATION:
      const simpleNotifications: SimpleNotification[] = state.notifications;
      simpleNotifications.push(action.payload);
      // if (simpleNotifications.length > 3) simpleNotifications.shift();
      setTimeout(() => { simpleNotifications.shift(); }, 3500);
      return { ...state, notifications: simpleNotifications };

    // Add Simple Notification
    case UiActions.CLEAR_SIMPLE_NOTIFICATIONS:
      return { ...state, notifications: [] };

    // Remove Simple Notification
    case UiActions.REMOVE_SIMPLE_NOTIFICATION:
      return { ...state, notifications: state.notifications.filter(x => x !== action.payload) };

    // Default
    default:
      return state;

  }
}



// WEBPACK FOOTER //
// ./src/app/core/reducers/ui.reducer.ts